
import axios from 'axios';
const HOSTAPI = process.env.REACT_APP_BASE_URL;
export const EventIdVerification = async (eventId: string) => {
    try {
        const response = await axios.get(`${HOSTAPI}/events/${eventId}`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};